import { Alert, Button, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { UserAvatar } from "minimals-template/components/user-avatar"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { If } from "lib/@components/switch"

export function ReviewRejectionBanner({ onEdit }) {
    const { accepted, decisionPayload } = useBoundContext()

    const isRejected = accepted === false
    const reason = decisionPayload?.reason
    if (!isRejected || !reason) return null

    const { userName, actionedOn } = decisionPayload
    const actionedOnDisplay = actionedOn ? new Date(actionedOn).format(DATE_FORMATS.dateAndTime) : ""
    const attribution = [userName, actionedOnDisplay].filter(Boolean).join(", ")
    const canEdit = typeof onEdit === "function"

    return (
        <Alert
            severity="error"
            data-cy="schedule-review-banner"
            action={canEdit ? renderEditButton() : undefined}
            sx={{ mb: 1, borderRadius: 2, "& .MuiAlert-message": { width: 1 } }}
        >
            <Typography variant="caption" sx={{ fontWeight: 600, color: "error.main" }}>
                Change Rejected
            </Typography>
            <Typography
                data-cy="schedule-review-banner-reason"
                variant="body2"
                sx={{ mt: 0.25, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
            >
                {reason}
            </Typography>
            <If truthy={Boolean(userName || actionedOnDisplay)}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1 }}>
                    <If truthy={Boolean(userName)}>
                        <UserAvatar
                            user={{ displayName: userName }}
                            data-cy="schedule-review-banner-avatar"
                            sx={{
                                width: 22,
                                height: 22,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                "& .MuiTypography-root": {
                                    fontSize: 11,
                                    lineHeight: 1,
                                    textAlign: "center",
                                    transform: "translateY(1px)",
                                },
                            }}
                        />
                    </If>
                    <Typography variant="caption" sx={{ color: "text.secondary" }}>
                        {attribution}
                    </Typography>
                </Stack>
            </If>
        </Alert>
    )

    function renderEditButton() {
        return (
            <Button
                size="small"
                color="primary"
                onClick={onEdit}
                startIcon={<Iconify icon="mdi:pencil" width={18} />}
                data-cy="inline-rejection-edit-button"
                aria-label="Edit rejection reason"
            >
                Edit
            </Button>
        )
    }
}
